<template>
    <v-app>
        <div class="header">
            <v-container>
                <v-row class="justify-content-between mx-2">
                    <img
                        class="logo"
                        src="/img/aente-logo-horizontal-white.png"
                    />
                    <router-link class="btn login" to="/login">{{
                        "common.enter" | trans
                    }}</router-link>
                </v-row>
                <v-row v-if="loading" class="justify-content-center">
                    <h1 class="profile-name-for-title">
                        {{ "form.public_profile_lang.loading" | trans }}
                    </h1>
                </v-row>
                <v-row v-else-if="publicProfile" class="justify-content-center">
                    <h1 class="profile-name-for-title">
                        {{ publicProfile.name }}
                    </h1>
                </v-row>
                <v-row v-else class="justify-content-center">
                    <h1 class="profile-name-for-title">
                        {{ "form.public_profile_lang.not_found" | trans }}
                    </h1>
                </v-row>
            </v-container>
        </div>
        <v-container v-if="!loading && publicProfile">
            <v-row class="mx-2">
                <v-col cols="12" class="profile-card m-1">
                    <v-row class="align-items-center">
                        <v-col cols="12" md="4">
                            <v-row
                                class="avatar justify-content-center top-section"
                            >
                                <img
                                    v-if="publicProfile.photo_path"
                                    :src="publicProfile.photo_path"
                                />
                                <img v-else src="/img/public-avatar.png" />
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-row>
                                <v-col cols="12" class="top-section">
                                    <span class="profile-name">{{
                                        publicProfile.name
                                    }}</span>
                                </v-col>
                                <v-col cols="12">
                                    <span class="profile-subtitle blue-font">{{
                                        publicProfile.specialty
                                    }}</span>
                                    <span
                                        v-if="publicProfile.city"
                                        class="profile-subtitle"
                                        >| {{ publicProfile.city }}</span
                                    >
                                </v-col>
                                <v-col
                                    v-if="publicProfile.attachs.length"
                                    cols="12"
                                >
                                    <div
                                        class="flex-start flex-wrap images-list mb-4"
                                    >
                                        <FsLightbox
                                            :toggler="imageToggler"
                                            :sources="publicProfile.attachs"
                                            :slide="index"
                                        />
                                        <div
                                            v-for="(
                                                image, i
                                            ) in publicProfile.attachs"
                                            :key="`images-${i}`"
                                            class="mx-1 mt-3 relative images-item"
                                            role="button"
                                            @click="openLightboxOnSlide(i)"
                                        >
                                            <template v-if="isImage(image)">
                                                <v-img
                                                    :lazy-src="image"
                                                    :src="image"
                                                    class="profile-pictures"
                                                ></v-img>
                                            </template>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12">
                                    <v-row class="mx-1">
                                        <a
                                            class="social-networks"
                                            v-if="publicProfile.instagram_url"
                                            target="_blank"
                                            :href="publicProfile.instagram_url"
                                        >
                                            <v-img
                                                src="/img/instagram.svg"
                                            ></v-img>
                                        </a>
                                        <a
                                            class="social-networks"
                                            v-if="publicProfile.facebook_url"
                                            target="_blank"
                                            :href="publicProfile.facebook_url"
                                        >
                                            <v-img
                                                src="/img/facebook.svg"
                                            ></v-img>
                                        </a>
                                        <a
                                            class="social-networks"
                                            v-if="publicProfile.linkedin_url"
                                            target="_blank"
                                            :href="publicProfile.linkedin_url"
                                        >
                                            <v-img
                                                src="/img/linkedin.svg"
                                            ></v-img>
                                        </a>
                                        <a
                                            class="social-networks"
                                            v-if="publicProfile.youtube_url"
                                            target="_blank"
                                            :href="publicProfile.youtube_url"
                                        >
                                            <v-img
                                                src="/img/youtube.svg"
                                            ></v-img>
                                        </a>
                                    </v-row>
                                </v-col>
                                <v-col
                                    v-if="publicProfile.feed_message"
                                    cols="12"
                                    class="mt-3"
                                >
                                    <span class="profile-feed"
                                        ><i>{{
                                            publicProfile.feed_message
                                        }}</i></span
                                    >
                                </v-col>
                                <v-col cols="12" class="mt-5">
                                    <router-link
                                        class="btn schedule"
                                        :to="createAppointmentRoute"
                                        >{{
                                            "common.schedule_now" | trans
                                        }}</router-link
                                    >
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row
                        v-if="publicProfile.description"
                        class="profile-data-section"
                    >
                        <v-col cols="12">
                            <v-row class="align-items-center">
                                <img class="badge" src="/img/badge-user.svg" />
                                <span class="profile-name">{{
                                    "common.about_heading" | trans
                                }}</span>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="profile-data-section-text">
                            <div
                                class="profile-text"
                                v-html="publicProfile.description"
                            ></div>
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="
                            publicProfile.qualifications &&
                            publicProfile.qualifications.length
                        "
                        class="profile-data-section"
                    >
                        <v-col cols="12">
                            <v-col cols="12">
                                <v-row class="align-items-center">
                                    <img
                                        class="badge"
                                        src="/img/badge-qualifications.svg"
                                    />
                                    <span class="profile-name">{{
                                        "common.qualifications" | trans
                                    }}</span>
                                </v-row>
                            </v-col>
                        </v-col>
                        <v-col cols="12" class="profile-data-section-text">
                            <p
                                class="profile-text highlight"
                                v-for="qualification in publicProfile.qualifications"
                            >
                                {{ qualification }}
                            </p>
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="
                            publicProfile.services &&
                            publicProfile.services.length
                        "
                        class="profile-data-section"
                    >
                        <v-col cols="12">
                            <v-col cols="12">
                                <v-row class="align-items-center">
                                    <img
                                        class="badge"
                                        src="/img/badge-services.svg"
                                    />
                                    <span class="profile-name">{{
                                        "form.heading.services" | trans
                                    }}</span>
                                </v-row>
                            </v-col>
                        </v-col>
                        <v-col cols="12" class="profile-data-section-text">
                            <p
                                class="profile-text highlight"
                                v-for="service in publicProfile.services"
                            >
                                {{ service }}
                            </p>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
        <div class="footer">
            <v-container>
                <v-row>
                    <v-col cols="12" md="4" class="footer-column">
                        <img
                            class="logo"
                            src="/img/aente-logo-horizontal-white.png"
                        />
                    </v-col>
                    <v-col cols="12" md="4" class="footer-column">
                        <v-row>
                            <v-col cols="12">
                                <span class="title">{{
                                    "form.heading.contacts" | trans
                                }}</span>
                            </v-col>
                            <v-col cols="12">
                                <div class="title-dash"></div>
                            </v-col>
                            <v-col cols="12">
                                <v-row class="align-items-center mt-5">
                                    <img
                                        class="icon"
                                        src="/img/location-icon.svg"
                                    />
                                    <span>17011 Beach Blvd. Suite 900, Office 14 <br>Huntington Beach, California 92647</span>
                                </v-row>
                                <v-row class="align-items-center mt-5">
                                    <img
                                        class="icon"
                                        src="/img/mail-icon.svg"
                                    />
                                    <a
                                        href="mailto:partners@aente.org"
                                        >partners@aente.org</a
                                    >
                                </v-row>
                                <v-row class="align-items-center mt-5">
                                    <img
                                        class="icon"
                                        src="/img/phone-icon.svg"
                                    />
                                    <span>+1 714 334 2754</span>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="4" class="footer-column">
                        <v-row class="mx-1">
                            <a
                                class="social-networks"
                                target="_blank"
                                href="https://www.instagram.com/testesmoleculares"
                            >
                                <v-img src="/img/instagram-white.svg"></v-img>
                            </a>
                            <a
                                class="social-networks"
                                target="_blank"
                                href="https://www.facebook.com/testesmoleculares"
                            >
                                <v-img src="/img/facebook-white.svg"></v-img>
                            </a>
                            <a
                                class="social-networks"
                                target="_blank"
                                href="https://br.linkedin.com/company/testes-moleculares-servicos-laboratoriais-ltda"
                            >
                                <v-img src="/img/linkedin-white.svg"></v-img>
                            </a>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="footer-last-item">
                    <p>
                        © {{ new Date().getFullYear() }} Aente - All rights
                        reserved.
                    </p>
                </v-row>
            </v-container>
        </div>
    </v-app>
</template>

<script>
import FsLightbox from "fslightbox-vue";
export default {
    name: "PublicPage",
    components: {
        FsLightbox,
    },
    data() {
        return {
            loading: false,
            publicProfile: undefined,
            imageToggler: false,
            index: 0,
        };
    },

    props: {
        alias: String,
    },

    mounted() {
        this.getPublicProfile();
    },

    computed: {
        createAppointmentRoute() {
            return "/customers/schedule";
        },
    },

    methods: {
        getPublicProfile() {
            this.loading = true;
            this.$store
                .dispatch("publicProfile/getPublicPage", this.alias)
                .then((res) => {
                    this.publicProfile = res?.data?.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        openLightboxOnSlide(index) {
            this.index = index + 1;
            this.imageToggler = !this.imageToggler;
        },
        isImage(path) {
            if (!path || typeof path !== "string") return false;
            return true;
        },
    },
};
</script>

<style lang="scss" scoped>
#app.theme--light{
    --public-text: #0c284c;
}
#app.theme--dark{
    --public-text: #005da9;
}
p,
span {
    color: var(--public-text);
    font-size: 1rem;
}
.header {
    background-color: #439dd3;
    background-image: url("/img/public-page-bg.png");
    background-image: -moz-linear-gradient(
            to bottom right,
            rgba(66, 155, 210, 0.52),
            rgba(164, 179, 185, 0.52)
        ),
        url("/img/public-page-bg.png");
    background-image: -webkit-linear-gradient(
            to bottom right,
            rgba(66, 155, 210, 0.52),
            rgba(164, 179, 185, 0.52)
        ),
        url("/img/public-page-bg.png");
    background-image: -o-linear-gradient(
            to bottom right,
            rgba(66, 155, 210, 0.52),
            rgba(164, 179, 185, 0.52)
        ),
        url("/img/public-page-bg.png");
    background-image: linear-gradient(
            to bottom right,
            rgba(66, 155, 210, 0.52),
            rgba(164, 179, 185, 0.52)
        ),
        url("/img/public-page-bg.png");
    .logo {
        height: 50px;
    }
}
.profile-name-for-title {
    margin: 3rem 2rem 9rem 2rem;
    color: white;
    font-size: 3rem;
    font-weight: 800;
}
.justify-content-center {
    justify-content: center;
}
.align-items-center {
    align-items: center;
}
.justify-content-between {
    justify-content: space-between;
}
.btn {
    &.login {
        height: 2.75rem;
        padding: 0 1.5rem;
        padding-top: 0.55rem;
        border-radius: 1.5rem;
        font-weight: 800;
        color: white;
        border-color: white;
        background-color: transparent;
        &:hover {
            color: black;
            background-color: white;
        }
    }
    &.schedule {
        height: 3.5rem;
        padding: 0 1rem;
        padding-top: 0.9rem;
        border-radius: 0.5rem;
        font-weight: 600;
        font-size: 1rem;
        color: white;
        border: none;
        background-color: #005da9;
        &:hover {
            -webkit-box-shadow: 0 0 15px rgba(0, 93, 169, 0.8);
            box-shadow: 0 0 15px rgba(0, 93, 169, 0.8);
        }
    }
}
.profile-card {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    margin-top: -7rem;
    margin-bottom: 3rem;
    background-color: var(--d-background);
    border-radius: 1.25rem;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    padding: 0 3rem 3rem 3rem !important;
}
.profile-name {
    color: var(--public-text);
    font-size: 2rem;
    font-weight: 800;
}
.top-section {
    margin-top: 3rem !important;
}
.profile-subtitle {
    font-size: 1rem;
    &.blue-font {
        color: #30aaf2;
    }
}
.avatar {
    img {
        height: 12.5rem;
        width: 12.5rem;
        border-radius: 50%;
        object-fit: cover;
    }
}
.profile-pictures {
    width: 4rem;
    border-radius: 0.5rem;
}
.social-networks {
    margin-right: 0.5rem;
}
.profile-data-section {
    border-top: 1px rgba(20, 20, 39, 0.19) solid;
    padding-top: 3rem;
}
.badge {
    border-radius: 0.5rem;
    background-color: rgba(0, 0, 0, 0.11);
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    padding: 0.5rem;
    margin-right: 1rem;
    img {
        width: 2rem;
    }
}
.profile-data-section-text {
    margin-top: 1rem;
}
.profile-text {
    font-size: 1.2rem;
    margin-bottom: 0;
    &.highlight {
        font-weight: bold;
    }
}
.footer {
    background-color: #005da9;
    p,
    span,
    a {
        color: white;
        margin: 0;
    }
    .logo {
        height: 50px;
    }
    .footer-column {
        padding: 1rem !important;
    }
    .title {
        font-size: 1.5rem;
        font-weight: bold;
        line-height: 1;
    }
    .title-dash {
        height: 1px;
        width: 3rem;
        border-top: 1px #f9f9f9 solid;
        margin-top: 0.375rem;
        margin-left: 0.175rem;
    }
    .social-networks {
        margin-right: 1rem;
    }
    .footer-last-item {
        border-top: 1px #f9f9f9 solid;
        padding: 1rem;
    }
    .icon {
        width: 1.25rem;
        margin-right: 0.75rem;
        margin-left: 1rem;
    }
}
</style>
